/** User-facing tooltip copy must never be a function reference (Vue 2 stringifies to [native code]). */
const STRINGIFIED_FUNCTION = /function\s*\(|\[native code\]/;

export function resolveControlTipText(text: unknown, context = 'control tip'): string {
    if (typeof text === 'function') {
        throw new Error(`${context}: tooltip text must be a string, not a function`);
    }
    const value = typeof text === 'string' ? text : String(text ?? '');
    if (STRINGIFIED_FUNCTION.test(value)) {
        throw new Error(`${context}: tooltip text looks like a stringified function`);
    }
    return value;
}
